import { createContext, ReactNode, useContext } from 'react';

import { ReturnExperienceData, useReturnExperience } from './returnExperience';

export type ReturnExperienceContextProps = {
  returnExperienceData: ReturnExperienceData | null;
  showReturnExperience: boolean | undefined;
};

export const ReturnExperienceContext = createContext<ReturnExperienceContextProps>({
  returnExperienceData: null,
  showReturnExperience: false,
});

interface ReturnExperienceContextProviderProps {
  showReturnExperience: boolean | undefined;
  children: ReactNode;
}

export const ReturnExperienceContextProvider = ({
  children,
  showReturnExperience,
}: ReturnExperienceContextProviderProps) => {
  const { returnExperienceData } = useReturnExperience();

  return (
    <ReturnExperienceContext.Provider value={{ returnExperienceData, showReturnExperience }}>
      {children}
    </ReturnExperienceContext.Provider>
  );
};

export const useReturnExperienceContext = () => useContext(ReturnExperienceContext);
